/**
 * Prepare text for rendering HTML dangerously. Intended to be used by WYSIWYG fields.
 * @param {string} text
 * @return {{__html: string}}
 */
function useFormattedText(text, limit = 0) {
  const stripNewLines = text.replace(/\\r\\n|(\\t)/i, '');
  if (limit > 0) {
    const truncated = stripNewLines.slice(0, limit);
    return { __html: stripNewLines.length > limit ? `${truncated}...` : truncated };
  }
  return { __html: stripNewLines };
}

export default useFormattedText;
